module.exports = __webpack_public_path__ + "static/media/reservation-title-close@2x.a44dccdd.png";